import './CustomPropertyLabel.css';

type CustomPropertyLabelProps = {
  htmlFor: string;
  children: React.ReactNode;
  required?: boolean;
};

export const CustomPropertyLabel = ({
  htmlFor,
  children,
  required,
}: CustomPropertyLabelProps) => (
  <label htmlFor={htmlFor} className="custom-label">
    {children}
    {required && <span className="text-red">{` *`}</span>}
  </label>
);
